import React from "react";
import Navbar from "../Home/Navbar";
import "./About.css";

function About() {
  return (
    <>
      <Navbar />
      <div className="about-container">
        <h2>About Periyar Writings</h2>
        <div className="about-description">
          <p>
            Periyar Writings is an online platform that aims to reform society socially and culturally by igniting a scientific temper and rational thinking among people.
          </p>
          <p>
           After the Aryan invasion, myriad invasions would have taken place in the Indian sub-continent. Regimes changed; Great revolutions had occurred on an international scale in politics. However, none of these revolutions or invasions challenged the dominance of the Vedas in India. Hence, Aryan domination wasn’t dissuaded.
          </p>
          <p>
            After twenty centuries, Periyar was born. He brought about a socio-cultural revolution to foster rational thinking, which started devastating the Aryan culture. Regimes and laws were changed. Numerous magazines were published, providing strong support for Periyar’s socio-cultural revolution by disseminating his principles throughout the country.
          </p>
          <p>
            As a continuation, we at Periyar Writings aim to globalise Periyar on the internet.
          </p>
        </div>
        <h3>Contact & Social Links</h3>
        <div className="about-links">
          <a href="https://www.instagram.com/periyar_writings?utm_source=qr&igsh=eDJ1ZXM0Z2YzNDZw" target="_blank" rel="noopener noreferrer">Instagram</a>
          <a href="mailto:revamp.org@gmail.com">Mail</a>
          <a href="https://www.facebook.com/share/1FtNSJquyo/" target="_blank" rel="noopener noreferrer">Facebook</a>
          <a href="https://youtube.com/@periyarscreen?si=q_PpOLiNAXPMhe5A" target="_blank" rel="noopener noreferrer">YouTube</a>
          <a href="https://x.com/Periyarwritings" target="_blank" rel="noopener noreferrer">Twitter</a>
          <a href="https://periyarbooks.com/collections/kaattaaru" target="_blank" rel="noopener noreferrer">Ebooks</a>
        </div>
      </div>
    </>
  );
}

export default About;
